import { observable, action, makeObservable, reaction } from 'mobx';
import productStore from './store.product';

class FilesStore {
  constructor() {
    makeObservable(this);
  }

  /**
   * 屏保本地图片
   */
  @observable
  localImg: FileOrNull = null;

  @action.bound
  setLocalImg(f: FileOrNull) {
    this.localImg = f;
  }

  /**
   * 自定义输入法
   */
  @observable
  customInput: FileOrNull = null;

  @action.bound
  setCustomInput(f: FileOrNull) {
    this.customInput = f;
  }

  /**
   * 自定义语言
   */
  @observable
  customLang: FileOrNull = null;

  @action.bound
  setCustomLang(f: FileOrNull) {
    this.customLang = f;
  }

  /**
   * 背景图
   */
  @observable
  bgImg: FileOrNull = null;

  @action.bound
  setBgImg(f: FileOrNull) {
    this.bgImg = f;
  }

  /**
   * 三方app
   */

  @observable
  thirdApp: File[] = [];

  @action.bound
  setThirdApp(fs: File[]) {
    this.thirdApp = fs;
  }

  @action.bound
  resetFiles() {
    this.setLocalImg(null);
    this.setBgImg(null);
    this.setCustomInput(null);
    this.setCustomLang(null);
    this.setThirdApp([]);
  }
}

const filesStore = new FilesStore();

reaction(
  () => productStore.current,
  () => {
    filesStore.resetFiles();
  },
);

export default filesStore;
